import {$get} from "../../core/js/Ajax.ts";
import {$, $$} from "../../core/js/Dom.ts";
import {showModalConfirmationCdsr} from "../../structure/js/CDSR.ts";
import {initLinkToOnglet} from "../../core/js/Onglets.ts";
import {openActionModal} from "../../core/js/Actions.ts";

document.addEventListener('DOMContentLoaded', () => {
    if(window.Openscop.url_get_alert_bloc) window.Openscop.refreshAlerts()
})

export function refreshAlerts(){
    $get(window.Openscop.url_get_alert_bloc).then((response) => {
        const parent = $<HTMLElement>('#openscop-alertes')
        if(!parent) return
        parent.innerHTML = response.body
        initLinkToOnglet(parent)
        $('.openscop-toggle-actions-menu')?.addEventListener('click', openActionModal)
        $$('.confirmer_cdsr').forEach(el => el.addEventListener('click', showModalConfirmationCdsr))
    })
}

window.Openscop.refreshAlerts = refreshAlerts